<script setup>

import { ref, watch, nextTick } from 'vue';
import Dialog from 'primevue/dialog';

const { routine } = defineProps({
    routine: Object
});

const visible = defineModel('visible', {
    type: Boolean
});

const emit = defineEmits(['declenchement']);

const textesValeursArgs = ref(null);
const composantsSaisie = ref([]);

watch(() => visible.value, (visible) => {
    if (visible) {
        textesValeursArgs.value = routine.arguments.map(arg => null);
        nextTick(() => {
            if (composantsSaisie.value.length > 0) {            
                composantsSaisie.value[0].focus();
            }
        });
    }
});

function declencher() {
    emit('declenchement', routine, textesValeursArgs.value);
}

</script>

<template>
    <Dialog 
        v-if="routine"
        v-model:visible="visible" 
        modal 
        :header="`Déclenchement de la routine : ${routine.libelle}`">
            <div class="saisie-valeurs-args" @keydown.enter.prevent="declencher()">
                <label v-if="routine.arguments.length === 0" class="aucun-argument">Aucun argument</label>
                <template v-for="(argument, index) of routine.arguments">
                    <label class="intitule" v-tooltip="argument.nom">
                        {{ argument.libelle }} :
                    </label>
                    <input type="text" spellcheck="false" v-model="textesValeursArgs[index]" ref="composantsSaisie" />
                </template>
            </div>
            <template #footer>
                <button 
                    class="bouton fas fa-check" 
                    :disabled="false"
                    @click="declencher()"/>
            </template>
    </Dialog>
</template>

<style scoped>

.aucun-argument {
    font-style: italic;
}

.saisie-valeurs-args {
	display: grid;
	grid-template-columns: auto auto;
	gap: 2px;
	align-items: start;
    margin-top: 2px;
}

</style>